import { Link } from "react-router-dom";
import logoImg from "./logo.png"; // <-- Agar file .jpg hai toh yeh, agar .png hai toh "./logo.png" likhein

export const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center no-underline group py-1">
    <img 
      src={logoImg} 
      alt="BHF Creative" 
      className="h-10 sm:h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
    />
  </Link>
);